import scrollElementTo from '../../lib/utils/animation/scrollElementTo';
import debounce from '../../lib/utils/events/debounce';

const SCREEN_WIDTH_SMALL: number = 980;
const PADDING_ALL_SCREEN_HEIGHT: number = 260;
const CLASS_CURRENT: string = 'current';
const CLASS_SCREEN: string = 'screen';
const CLASS_MOVE: string = 'move';
// скорость прокрутки страницы
const animateTime: number = 1000;
const animateTimeHide: number = 600;

// высота экрана
let screenHeight: number;
// Количество экранов
let screenCount: number = 0;
// запущен ли скрипт скролла страницы по экранам
let listElementsMargin: HTMLLIElement[] = [];
// массив с элементами навигации
let arrayNavigationMenuElements: HTMLLIElement[] = [];
// активна ли прокрутка?
let isActiveScroll: boolean = false;
// состояние прокрутки страницы
let scrollState: number = 0;
// массив высот всех элементов
const arrayHeightElements: number[] = [];
// сколько раз прокрутился экран
let countScroll: number = 0;
// Высоты контейнера
let heightContainer: number = 0;
// Кнопка прокрутки вниз
let buttonScrollBottom: HTMLButtonElement;

let storeHeight: number = 0;
let heightElement: number = 0;

// инициализация
function main(): void
{
	const main = document.querySelector( 'body>main' ) as HTMLElement;

	// Проверка на соответствующие страницы
	if ( !main
		|| document.body.classList.contains( 'index' )
		|| document.body.classList.contains( 'contacts' )
		|| document.body.classList.contains( 'error' ) 
		|| document.body.classList.contains( 'main' )
		|| document.body.classList.contains( 'search' )
		|| document.documentElement.classList.contains( 'ua-mobile' ))
	{
		return;
	}
	
	// Контейнер с элементами
	const containerElements = main.querySelector( 'main>ul' ) as HTMLElement;
	
	if ( !containerElements )
	{
		return;
	}
	
	// Контейнер меню навигации
	const navigateMenuContainer = document.querySelector( 
		'main>aside.navigation>div.scroll-container>ul.navigation' ) as HTMLUListElement;
	// Заголовок сверху страницы
	const title = main.querySelector( 'h2' ) as HTMLElement;
	
	scrollState = window.pageYOffset;
	
	registerHandlers( main, containerElements, title, navigateMenuContainer );
}

// регистрация обработчиков
function registerHandlers(
	main : HTMLElement,
	containerElements: HTMLElement,
	title: HTMLElement,
	navigateMenuContainer: HTMLUListElement
): void
{
	const boundDocumentClickHandler: ( event: Event ) => void = ( event: Event ) =>
		targetClick( event, main );
	const boundDocumentScrollHandler: ( event: WheelEvent ) => void = 
		debounce( ( event: WheelEvent ) => targetScroll( main, navigateMenuContainer, event ), 100, true );

	let unRegisterHandlers = (): void =>
	{
		buttonScrollBottom.removeEventListener( 'click', boundDocumentClickHandler );
		window.removeEventListener( 'wheel', boundDocumentScrollHandler );
	};
	
	screenHeight = updateResizeVariables(
		main,
		containerElements,
		title,
		navigateMenuContainer,
		boundDocumentScrollHandler,
		boundDocumentClickHandler,
		unRegisterHandlers
	);
	// Событие по открытию лайтбокса
	containerElements.addEventListener(
		'ShowLightbox:open',
		() =>
		{
			clearHeightContainer(containerElements);
		}	
	);
	// Событие по закрытию лайтбокса
	window.addEventListener(
		'ShowLightbox:close',
		() =>
		{
			installScrollHeight( containerElements );
		}	
	);
	window.addEventListener(
		'resize',
			() => updateResizeVariables(
				main,
				containerElements,
				title,
				navigateMenuContainer,
				boundDocumentScrollHandler,
				boundDocumentClickHandler,
				unRegisterHandlers
			)
	);
}

// пересчёт переменных при ресайзе окна
function updateResizeVariables(
	main : HTMLElement,
	containerElements: HTMLElement,
	title: HTMLElement,
	navigateMenuContainer: HTMLUListElement,
	boundDocumentScrollHandler: ( event: WheelEvent ) => void,
	boundDocumentClickHandler: ( event: Event ) => void,
	unRegisterHandlers: () => void
): number
{
	if ( !isModeMobile() )
	{
		// Высота заголовка
		let titleHeight = title.offsetHeight;
		// Размер нижнего отступа у заголовка
		let titleMarginBottom = window.getComputedStyle( title ).marginBottom;
		// Сумма высоты заголовка и нижнего отступа
		let titleAllHeight: number = titleHeight + parseInt( titleMarginBottom );
		// Высота экрана без высот шапки и футера
		screenHeight = document.documentElement.clientHeight - PADDING_ALL_SCREEN_HEIGHT;
		// Очищаю массив
		arrayHeightElements.length = 0;

		if ( !containerElements.classList.contains( CLASS_CURRENT ) )
		{
			// Проверка на заполненность массива с элементами с отступом и очищение его
			if ( listElementsMargin.length >= 1 )
			{
				clearArray();
				removeChildNavigationMenu( arrayNavigationMenuElements, navigateMenuContainer );
				// Если есть, то удалить
				if ( buttonScrollBottom )
				{
					unRegisterHandlers();
					const parentNavigateMenuContainer = (navigateMenuContainer as any).closest('aside.navigation');
					parentNavigateMenuContainer.removeChild( buttonScrollBottom );
				}
			}

			// Если класс есть на контейнере, то удалить его
			if ( main.classList.contains( CLASS_SCREEN ) )
			{
				main.classList.remove( CLASS_SCREEN );
			}

			// Вызов функции разделения страницы на экраны
			initScroll( main, containerElements, titleAllHeight,
				navigateMenuContainer, boundDocumentScrollHandler, boundDocumentClickHandler);
		}

		// Если прокрутка равна 0, то шаг прокрутки 0
		if ( window.pageYOffset === 0 )
		{
			countScroll = 0;
		}
		else
		{
			// Если прокрутка больше 0, то высчитывается шаг прокрутки
			countScroll = window.pageYOffset / document.documentElement.clientHeight;
		}
		// Округление( на всякий случай )
		countScroll = Math.round( countScroll );
		// countScroll = 3;
		// Высчитываю состояние прокрутки
		scrollState = countScroll * document.documentElement.clientHeight;
		// Функция плавной прокрутки
		scrollElementTo( window, scrollState, 10 );

		// Если есть элемент в массиве с индексом
		if ( arrayNavigationMenuElements[countScroll] )
		{
			arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );

			if ( countScroll === ( screenCount - 1 ) )
			{
				addClassButtonScrollBottom( buttonScrollBottom );
			}
		}
		else
		{
			scrollElementTo( window, 0, 1000 );
		}
	}
	else
	{
		containerElements.style.height = '';
		main.classList.remove( CLASS_SCREEN );

		if ( listElementsMargin.length >= 1 )
		{
			clearArray();
			removeChildNavigationMenu( arrayNavigationMenuElements, navigateMenuContainer );
			// Если есть, то удалить
			if ( buttonScrollBottom )
			{
				unRegisterHandlers();
				const parentNavigateMenuContainer = (navigateMenuContainer as any).closest('aside.navigation');
				parentNavigateMenuContainer.removeChild( buttonScrollBottom );
			}
		}
	}
	
	return screenHeight;
}

// срабатывает при скролле колесом мыши
function targetScroll( main: HTMLElement, navigateMenuContainer: HTMLUListElement, event: WheelEvent ): void
{
	// Активна ли прокрутка
	if ( isActiveScroll
		|| ( event.deltaY === 0 ) 
		|| ( event.target as any).closest( 'ul.current' ) 
		|| ( event.target as any).closest( 'div.controls' ) )
	{
		return;
	}
	
	if ( navigateMenuContainer.contains(event.target as HTMLElement) )
	{
		event.preventDefault();
		return;
	}	

	event.preventDefault();
	
	// Направление прокрутки
	if ( event.deltaY >= 0 )
	{
		if ( scrollState < (screenCount - 1) * (screenHeight + PADDING_ALL_SCREEN_HEIGHT) )
		{
			isActiveScroll = true;
			scrollState += (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
			
			if ( arrayNavigationMenuElements[countScroll] )
			{
				addClassButtonScrollBottom( buttonScrollBottom );
				
				arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
				countScroll++;
				arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );

				if ( countScroll !== ( screenCount - 1 ) )
				{
					setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTimeHide );
				}
			}

			main.classList.add( CLASS_MOVE );
			setTimeout( () => main.classList.remove( CLASS_MOVE ), animateTimeHide );
			
			toScroll( scrollState );
		}
		else
		{
			scrollState = (screenCount - 1) * (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
		}
	}
	else if ( event.deltaY >= -(screenHeight + PADDING_ALL_SCREEN_HEIGHT) )
	{
		if ( scrollState > 0 )
		{
			isActiveScroll = true;
			scrollState -= (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
			
			if ( arrayNavigationMenuElements[countScroll] )
			{
				addClassButtonScrollBottom( buttonScrollBottom );
				setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTimeHide );
				
				arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
				countScroll--;
				arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );
			}

			main.classList.add( CLASS_MOVE );
			setTimeout( () => main.classList.remove( CLASS_MOVE ), animateTimeHide );
			
			toScroll( scrollState );
		}
		else
		{
			scrollState = 0;
		}
	}
}

// срабатывает при клике
function targetClick( event: Event, main: HTMLElement ): void
{
	if ( isActiveScroll
		|| ( event.target as any).closest( 'ul.current' ))
	{
		return;
	}
	
	if ( event.target === buttonScrollBottom )
	{
		isActiveScroll = true;
		scrollState += (screenHeight + PADDING_ALL_SCREEN_HEIGHT);

		if ( arrayNavigationMenuElements[countScroll] )
		{
			addClassButtonScrollBottom( buttonScrollBottom );

			arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
			countScroll++;
			arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );
			
			if ( countScroll !== ( screenCount - 1 ) )
			{
				setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTimeHide );
			}
		}
	}
	else
	{
		isActiveScroll = true;
		
		const element: any = event.target;
		const index: number = arrayNavigationMenuElements.indexOf( element.parentElement );
		
		scrollState = (screenHeight + PADDING_ALL_SCREEN_HEIGHT) * index;
		
		if ( arrayNavigationMenuElements[countScroll] )
		{
			addClassButtonScrollBottom( buttonScrollBottom );

			arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
			countScroll = index;
			arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );
			
			if ( index !== arrayNavigationMenuElements.length - 1 )
			{
				setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTimeHide );
			}
		}
	}

	main.classList.add( CLASS_MOVE );
	setTimeout( () => main.classList.remove( CLASS_MOVE ), animateTimeHide );
	
	toScroll( scrollState );
}

// скролит страницу на заданную величину
function toScroll( scrollState: number ): void
{
	scrollElementTo( window, scrollState, animateTime );
	setTimeout(
		() =>
		{
			isActiveScroll = false;
		},animateTime
	);
}

// инициализация скрипта прокрутки страницы по экранам
function initScroll(
	main : HTMLElement,
	containerElements: HTMLElement,
	titleAllHeight: number,
	navigateMenuContainer: HTMLElement,
	boundDocumentScrollHandler: ( event: WheelEvent ) => void,
	boundDocumentClickHandler: (event: Event) => void
): void
{
	// Все элементы в ul
	let list: HTMLCollection = containerElements.children;
	// Номер элемента который не влез
	let numberElementMargin: number = 0;
	// Позиция элементов от верха
	let positionTop: number = 0;
	// ППомещается ли элемент в экран
	let isNumberCount: boolean = false;
	// Высота экрана с высотами шапки и футера
	let screen: number = (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
	// Цикл определяющий какой номер элемента не влез и все высоты элементов
	Array.prototype.forEach.call(
		list,
		( item: HTMLLIElement, index: number ) =>
		{
			// Высота отступа элемента от верха + высота прокрутки окна + высота прокрутки блока main
			if( ( item.getBoundingClientRect().top + window.pageYOffset + main.scrollTop ) 
				>= (screenHeight - titleAllHeight)
			// if( ( item.getBoundingClientRect().top + window.pageYOffset ) >= (screenHeight)
				&& !isNumberCount )
			{
				numberElementMargin = index;
				positionTop = (item.getBoundingClientRect().top + window.pageYOffset + main.scrollTop) - screenHeight;
				isNumberCount = true;
			}
			// Записываю в массив все высоты элементов
			arrayHeightElements.push( item.offsetHeight );
		}
	);
	
	// Если все элементы влезли, то выходим из функции
	if ( numberElementMargin === 0 )
	{
		containerElements.style.height = '';
		main.classList.remove( CLASS_SCREEN );
		return;
	}
	
	// Вешаю обработчик на колесо мыши
	window.addEventListener( 'wheel', boundDocumentScrollHandler );
	// console.log(event.target);
	main.classList.add( CLASS_SCREEN );
	
	// Цикл где расставляется марджин элементам
	for ( let i: number = numberElementMargin; i < list.length; i+=numberElementMargin )
	{
		// Функция сравнения двух высот, возвращает большую высоту
		const compareNumbers = ( a: number, b: number = 0 ) =>
		{
			if ( a >= b )
			{
				return a;
			}
			else
			{
				return b;
			}
		};
		// Выделенный элемент
		const currentElement = list[i] as HTMLLIElement;
		// Если меньше 2 элементов или 2 помещаются в экран
		if ( numberElementMargin <= 2 )
		{
			// Максимальная высота элемента
			let maxHeightElement: number = arrayHeightElements[i] / 2;
			// Максимальная высота предыдущего элемента
			let maxHeightPrevElement: number = compareNumbers( arrayHeightElements[i-1], arrayHeightElements[i-2] );
			// Верхнее положение предыдущего элемента
			let topPrevElement: number = 0;
			// Если есть соседний эелемент ( сравниваем с ним ), если нет берём высоту первого
			if ( arrayHeightElements[i+1] )
			{
				maxHeightElement = compareNumbers( arrayHeightElements[i], arrayHeightElements[i+1] ) / 2;
			}
			// Предыдущий элемент
			if ( currentElement.previousElementSibling )
			{
				topPrevElement = currentElement.previousElementSibling.getBoundingClientRect().top + window.pageYOffset;
			}

			/*currentElement.style.marginTop =
				( (screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
				- maxHeightElement + screen
				- ( topPrevElement
					+ maxHeightPrevElement - 40
				) + 'px';*/

			currentElement.style.marginTop =
				(( (screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
				- maxHeightElement + screen
				- ( topPrevElement
					+ maxHeightPrevElement
				)) - 
				( ( (screenHeight) / 2) - titleAllHeight - maxHeightElement) 
				+ 'px';
			
			listElementsMargin.push( currentElement );
			// Следующий элемент
			if ( currentElement.nextElementSibling )
			{
				// Следующий элемент
				const nextElement = currentElement.nextElementSibling as HTMLLIElement;

				nextElement.style.marginTop =
					( (screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
					- maxHeightElement + screen
					- ( topPrevElement
						+ maxHeightPrevElement
					) - 
					( ( (screenHeight) / 2) - titleAllHeight - maxHeightElement) 
					+ 'px';
				
				/*nextElement.style.marginTop =
					( (screenHeight + PADDING_ALL_SCREEN_HEIGHT) / 2)
					- maxHeightElement + screen
					- ( topPrevElement
						+ maxHeightPrevElement - 40
					) + 'px';*/

				listElementsMargin.push( nextElement );
			}
		}
		else
		{
			// Первый элемент от выбранного
			let nextElementOne: number = 0;
			// Второй элемент от выбранного
			let nextElementTwo: number = 0;
			// Третий элемент от выбранного
			let nextElementThree: number = 0;
			// Четвёртый элемент от выбранного
			let nextElementTwoFourth: number = 0;
			// Пятый элемент от выбранного
			let nextElementTwoFifth: number = 0;
			// Шестой элемент от выбранного
			let nextElementTwoSixth: number = 0;
			// Седьмой элемент от выбранного
			let nextElementTwoSeventh: number = 0;
			// Максимальная высота элемента
			let maxHeightElement: number = 0;
			// Максимальная высота следующей первой пары элементов
			let maxHeightNextElement: number = 0;
			// Максимальная высота следующей второй пары элементов
			let maxHeightFollowingFourthElement: number = 0;
			// Максимальная высота следующей третьей пары элементов
			let maxHeightFollowingSixthElement: number = 0;
			// Максимальная высота предыдущей пары элементов
			let maxHeightPrevElement: number = 0;
			// Верхнее положение предыдущего элемента
			let topPrevElement: number = 0;

			if ( arrayHeightElements[i+1] )
			{
				nextElementOne = arrayHeightElements[i+1];
			}
			if ( arrayHeightElements[i+2] )
			{
				nextElementTwo = arrayHeightElements[i+2];
			}
			if ( arrayHeightElements[i+3] )
			{
				nextElementThree = arrayHeightElements[i+3];
			}
			if ( numberElementMargin >= 6 )
			{
				if ( arrayHeightElements[i+4] )
				{
					nextElementTwoFourth = arrayHeightElements[i+4];
				}
				if ( arrayHeightElements[i+5] )
				{
					nextElementTwoFifth = arrayHeightElements[i+5];
				}

				maxHeightFollowingFourthElement = ( compareNumbers( nextElementTwoFourth, nextElementTwoFifth ) / 2 );
			}
			if ( numberElementMargin >= 8 )
			{
				if ( arrayHeightElements[i+6] )
				{
					nextElementTwoSixth = arrayHeightElements[i+6];
				}
				if ( arrayHeightElements[i+7] )
				{
					nextElementTwoSeventh = arrayHeightElements[i+7];
				}

				maxHeightFollowingSixthElement = ( compareNumbers( nextElementTwoFourth, nextElementTwoFifth ) / 2 );
			}

			maxHeightElement = ( compareNumbers( arrayHeightElements[i], nextElementOne ) / 2 );
			maxHeightNextElement = ( compareNumbers( nextElementTwo, nextElementThree ) / 2 );
			maxHeightPrevElement = ( compareNumbers( arrayHeightElements[i-1], arrayHeightElements[i-2] ) );
			topPrevElement = ( (list[i-1] as HTMLElement).getBoundingClientRect().top + window.pageYOffset );

			/*currentElement.style.marginTop =
				( (screenHeight + PADDING_ALL_SCREEN_HEIGHT ) / 2 )
				- ( maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
				+ maxHeightFollowingSixthElement ) + screen
				- ( topPrevElement + maxHeightPrevElement ) + 'px';*/
			
			currentElement.style.marginTop =
				(( (screenHeight + PADDING_ALL_SCREEN_HEIGHT ) / 2 )
				- ( maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
				+ maxHeightFollowingSixthElement ) + screen
				- ( topPrevElement + maxHeightPrevElement )) -
				( ( (screenHeight) / 2) - titleAllHeight - 
				( maxHeightElement + maxHeightNextElement + 
				maxHeightFollowingFourthElement + maxHeightFollowingSixthElement) ) 
				+ 'px';
			
			listElementsMargin.push( currentElement );

			if ( list[i+1] )
			{
				const nextElement = list[i+1] as HTMLLIElement;

				/*nextElement.style.marginTop =
					( ( screenHeight + PADDING_ALL_SCREEN_HEIGHT ) / 2 )
					- ( maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
					+ maxHeightFollowingSixthElement ) + screen
					- ( topPrevElement + maxHeightPrevElement ) + 'px';*/

				nextElement.style.marginTop =
					(( (screenHeight + PADDING_ALL_SCREEN_HEIGHT ) / 2 )
					- ( maxHeightElement + maxHeightNextElement + maxHeightFollowingFourthElement
					+ maxHeightFollowingSixthElement ) + screen
					- ( topPrevElement + maxHeightPrevElement )) -
					( ( (screenHeight) / 2) - titleAllHeight -
					( maxHeightElement + maxHeightNextElement +
					maxHeightFollowingFourthElement + maxHeightFollowingSixthElement) )
					+ 'px';

				listElementsMargin.push( nextElement );
			}
		}

		screen = screen + (screenHeight + PADDING_ALL_SCREEN_HEIGHT);
	}
	
	screenCount = Math.ceil( list.length / numberElementMargin );
	heightContainer = ( screenCount * ( screenHeight + PADDING_ALL_SCREEN_HEIGHT ) )
		- ( document.documentElement.scrollHeight - containerElements.offsetHeight );
	
	containerElements.style.height = heightContainer + 'px';
	heightElement = heightContainer;
	
	createdNavigationMenu( main, navigateMenuContainer, screenCount, boundDocumentClickHandler );
}

// Удаление элементов в массиве
function removeChildNavigationMenu( array: HTMLLIElement[], container: HTMLElement ): void
{
	array.forEach(
		( item: HTMLLIElement ) =>
		{
			container.removeChild( item );
		}
	);

	array.length = 0;
}
// Очищение массива и обнуление отступов
function clearArray(): void
{
	listElementsMargin.forEach(
		( item: HTMLLIElement ) =>
		{
			item.style.marginTop = '';
		}
	);

	listElementsMargin.length = 0;
}

// создание меню навигации
function createdNavigationMenu( 
	main: HTMLElement, navigateMenuContainer: HTMLElement, countScreenOnPage: number, 
	boundDocumentClickHandler: ( event: Event ) => void ): HTMLElement
{
	for ( let i = 0; i < countScreenOnPage; i++ )
	{
		// Создание элемента а
		const bulitElement: HTMLAnchorElement = document.createElement( 'a' );
		// Создание элемента li
		const bulitElementContainer: HTMLLIElement = document.createElement( 'li' );
		
		bulitElement.addEventListener( 'click', ( event: Event ) => targetClick( event, main ) );
		
		arrayNavigationMenuElements.push( bulitElementContainer );

		bulitElementContainer.appendChild( bulitElement );
		navigateMenuContainer.appendChild( bulitElementContainer );
	}

	// Создание элемента button ( кнопки прокрутки вниз )
	const button: HTMLButtonElement = document.createElement( 'button' );
	button.classList.add( 'scroll-bottom' );
	button.textContent = 'Показать ещё';
	button.addEventListener( 'click', boundDocumentClickHandler );
	buttonScrollBottom = button;
	
	const parentNavigateMenuContainer = (navigateMenuContainer as any).closest('aside.navigation');
	parentNavigateMenuContainer.appendChild( buttonScrollBottom );
	
	return navigateMenuContainer;
}
// Добавление класса кнопки прокрутки вниз
function addClassButtonScrollBottom( button: HTMLButtonElement ): void
{
	button.classList.add( 'hide' );
}
// Удаление класса кнопки прокрутки вниз
function removeClassButtonScrollBottom( button: HTMLButtonElement ): void
{
	button.classList.remove( 'hide' );
}
// Очистка высоты у ul
function clearHeightContainer( containerElements: HTMLElement ): void
{
	containerElements.style.height = '';
}

function installScrollHeight( containerElements: HTMLElement ): void
{
	if (!isModeMobile())
	{
		if (heightElement !== 0)
		{
			let test = 0;
			
			containerElements.style.height = heightElement + 'px';
			
			arrayNavigationMenuElements.some(
				(item: HTMLLIElement, index: number) =>
				{
					if (item.classList.contains(CLASS_CURRENT))
					{
						test = index;
						
						return true;
					}
					return false;
				}
			);

			const rezult = test * document.documentElement.clientHeight;
			scrollElementTo(window, rezult, 10);
		}
	}
}

function isModeMobile()
{
	return ( window.innerWidth < SCREEN_WIDTH_SMALL );
}

export {
	main as default,
};
